import { dataService } from '../../data';

import { DataObject, ObjectOptions } from "../base";
import { CreateObject } from "../item";

import { PlaceType } from '../types';
import { QrCodeType } from '../types';
import { SessionType } from '../types';

/**
 * Global QR scan entry: unique id per mesa for app access via scan. Sync root for guest "table" load.
 */
const _schema = {
    "name": "QRSCAN",
    "fields": [
        { name: "place", type: "objid" },
        { name: "status", type: "string", default: "AC" },
        { name: "authorization", type: "string" },
        { name: "qrcode", type: "objid" },
        { name: "number", type: "number" },
        { name: "alias", type: "string" }
    ],
    relate: [
        { direction: ">", target: "PLACE", by: "place", name: "place", reason: "place", child: false, class: PlaceType },
        { direction: ">", target: "QRCODE", by: "qrcode", name: "qrcode", reason: "qrcode", child: false, class: QrCodeType },
        { direction: "<", target: "SESSION", by: "qrscan", name: "session", reason: "sessions", child: true, class: SessionType }
    ]
} as const;

const _QrScanClass = CreateObject(_schema);
if (!_QrScanClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

export class QrScan extends _QrScanClass {
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): QrScan {
        return this._Copy(store) as QrScan;
    }
}
